import { Badge } from "@/components/ui/badge";

export function BundleBadge() {
  return (
    <Badge
      variant="outline"
      className="border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-800 dark:bg-sky-950 dark:text-sky-300 text-[10px] px-1.5 py-0 h-4 font-medium"
      aria-label="Bundle product"
    >
      Bundle
    </Badge>
  );
}
